<nav ngbNav #navAttachments="ngbNav" class="nav-tabs">
  <ng-container ngbNavItem>
    <a ngbNavLink>Add Attachments</a>
    <ng-template ngbNavContent>
      <div class="text-center bg-white" *ngIf="loading">
        <div class="py-3 px-2">
          <i class="fas fa-spinner fa-pulse fa-3x"></i>
        </div>
      </div>
      <div *ngIf="!loading">
        <div class="py-3 px-2">
          <div class="row my-2 mx-2">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Document Type</label>
                <select class="form-control" [(ngModel)]="search_params.document_type_id">
                  <option *ngFor="let document_type of search_options.document_types" [value]="document_type.value">{{ document_type.label }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Author</label>
                <select class="form-control" [(ngModel)]="search_params.document_author_id">
                  <option *ngFor="let document_author of search_options.document_authors" [value]="document_author.value">{{ document_author.label }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4 text-center">
              <pagination
                class="pagination-sm text-center justify-content-center"
                (pageChanged)="loadDocuments($event)"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [(ngModel)]="search_params.page"
                [itemsPerPage]="search_params.per_page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
              ></pagination>
            </div>
          </div>
          <div class="row my-2 mx-2">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Tags</label>
                <select class="form-control" multiple="true" [(ngModel)]="search_params.tags">
                  <option *ngFor="let tag of search_options.tags" [value]="tag">{{ tag }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Content</label>
                <textarea class="form-control" [(ngModel)]="search_params.content"></textarea>
              </div>
            </div>
            <div class="col-sm-4 text-center">
              <label>Number of documents</label>
              <p>{{ count }}</p>
            </div>
          </div>
          <div class="row my-2 mx-2">
            <div class="col-sm-4 ml-auto mr-auto text-center">
              <button type="button" class="btn btn-primary" (click)="loadDocuments()">Search</button>
            </div>
          </div>
          <div class="table-responsive">
          <table class="table table-striped" style="font-size: 80%">
            <thead>
              <tr>
                <th class="attachment-action-column"></th>
                <th>
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="loadDocuments(null, 'Type')">Type</button>
                </th>
                <th style="white-space: nowrap">
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="loadDocuments(null, 'Created')">Created</button>
                </th>
                <th style="white-space: nowrap">
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="loadDocuments(null, 'Authored')">Authored</button>
                </th>
                <th>
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="loadDocuments(null, 'Authors')">Authors</button>
                </th>
                <th>
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="loadDocuments(null, 'Name')">Name</button>
                </th>
                <th>
                  <button type="button" class="btn btn-link btn-sm p-0" disabled="true">Notes</button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let document of documents">
                <td class="attachment-action-column">
                  <button type="button" (click)="toggleAttachment(document)" [ngClass]="{ 'btn-success': document.selected, 'btn-primary': !document.selected }" class="btn btn-sm">
                    {{ document.selected ? 'Added' : 'Add' }}
                  </button>
                </td>
                <td>{{ document.document_type }}</td>
                <td style="white-space: nowrap">{{ document.created_at }}</td>
                <td style="white-space: nowrap">{{ document.authored_at }}</td>
                <td>
                  <div *ngFor="let author of document.authors">{{ author }}</div>
                </td>
                <td>
                  <span *ngIf="!document.file_present">
                    <span *ngIf="document.name.length > 20">{{ document.shortName }}</span>
                    <span *ngIf="document.name.length <= 20">{{ document.name }}</span>
                  </span>
                  <a class="btn btn-link btn-sm p-0" *ngIf="document.file_present" [href]="'/documents/' + document.id + '/download'" [title]="(document.document_type || '') + (document.document_type && document.notes ? ' — ' : '') + (document.notes || '')">
                    <span *ngIf="document.name.length > 20">{{ document.shortName }}</span>
                    <span *ngIf="document.name.length <= 20">{{ document.name }}</span>
                  </a>
                  <app-badge *ngIf="!document.file_present" badgeType="warning">File missing</app-badge>
                  <span *ngIf="document.autosaved"><br />(Autosaved)</span>
                </td>
                <td style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap" [title]="document.notes">{{ document.notes }}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem>
    <a ngbNavLink>Attachments Selected - {{attachments.length}}</a>
    <ng-template ngbNavContent>
      <div class="card my-1" *ngFor="let attachment of attachments">
        <div class="card-body">
          <div class="row">
            <div class="col-4">
              <div class="row">
                <div class="col-6 text-right">Name:</div>
                <div class="col-6">
                  <strong>{{ attachment.name }}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-right">Type:</div>
                <div class="col-6">
                  {{ attachment.document_type }}
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-right">Created:</div>
                <div class="col-6">
                  {{ attachment.created_at }}
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-right">Authored:</div>
                <div class="col-6">
                  {{ attachment.authored_at }}
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-right">Authors:</div>
                <div class="col-6">
                  {{ attachment.authors.join(', ') }}
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <div class="btn-group btn-group-sm" *ngIf="attachment.file_present" role="group">
                    <button type="button" class="btn btn-outline-secondary" (click)="miniPreview(attachment)">Mini-view</button>
                    <a role="button" class="btn btn-outline-secondary" [href]="'/documents/' + attachment.id + '/download?disposition=inline'" target="_blank">View</a>
                  </div>
                  <app-badge badgeType="warning" *ngIf="!attachment.file_present">File missing</app-badge>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <iframe #miniPreviewIframe [class]="'document_attachment_mini_iframe_' + attachment.id" frameborder="0"></iframe>
                </div>
              </div>
            </div>
            <div class="col-8">
              <div class="form-group">
                <div class="custom-control custom-checkbox" (click)="attachment.send_original = !attachment.send_original; attachmentsSelected.emit(this.attachments)">
                  <input type="checkbox" [checked]="attachment.send_original" [(ngModel)]="attachment.send_original" class="custom-control-input" />
                  <label class="custom-control-label">Send Original</label>
                </div>
                &nbsp;&nbsp;&nbsp;
                <div class="custom-control custom-checkbox" (click)="attachment.quality = !attachment.quality; attachmentsSelected.emit(this.attachments)">
                  <input type="checkbox" [checked]="attachment.quality" [(ngModel)]="attachment.quality" class="custom-control-input" />
                  <label class="custom-control-label">Print on good paper</label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label>Copies</label>
                  <input type="number" class="form-control" min="0" (change)="attachmentsSelected.emit(this.attachments)" [(ngModel)]="attachment.copies" />
                </div>
                <div class="col-6">
                  <label>Pages</label>
                  <input type="text" class="form-control" [(ngModel)]="attachment.pages" (change)="attachmentsSelected.emit(this.attachments)" />
                </div>
              </div>
              <div class="form-group">
                <label>Instructions</label>
                <textarea class="form-control" [(ngModel)]="attachment.instructions" (change)="attachmentsSelected.emit(this.attachments)"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</nav>
<div [ngbNavOutlet]="navAttachments"></div>
